var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"aHeader"},[_vm._v(_vm._s(_vm.data.mhGgbt))]),_c('div',{staticClass:"aTitle"}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.data.mhGgnr)}})])}
var staticRenderFns = []

export { render, staticRenderFns }